import { apply, put, takeLatest } from 'redux-saga/effects';

import { getSingleton } from '@occc-app/Activate/api';
import { EarningMechanism as EarningMechanismAPI } from '@occc-app/Activate/apiTypes';
import { safeAsync } from '@occc-app/lib/safeAsync';
import { ClientError } from '@occc-app/lib/client';

import actions from './actions';
import { deserializeEarningMechanism } from './deserializers';

import { types as offerTypes, ActionCreators as OfferActionCreators } from '../../../redux';

// Request Earning Mechanism
function* requestEarningMechanism(action: ReturnType<OfferActionCreators['RequestOfferOK']>) {
  const core = getSingleton();
  const earningMechanism = action.earningMechanisms[0];
  if (!earningMechanism) {
    yield put(actions.requestEarningMechanismsOK());
    return;
  }

  const earningMechanismId = earningMechanism.id!;

  yield put(actions.requestEarningMechanism(earningMechanismId));

  const earningMechanismData = (yield apply(
    core,
    core.earningMechanisms.id(earningMechanismId).show,
    [{}],
  )) as { data: EarningMechanismAPI };

  const { selectedAwardConfiguration, selectedEMConfiguration } = deserializeEarningMechanism(
    earningMechanismData.data,
  );
  yield put(actions.requestEarningMechanismOK(selectedAwardConfiguration, selectedEMConfiguration));
}

const sagas = {
  requestEarningMechanism: safeAsync(requestEarningMechanism, (error: ClientError, action) => {
    const errorMessages = error.errorMessages || [
      {
        message: `Unable to request Earning Mechanism: ${action.earningMechanisms}`,
      },
    ];
    return actions.requestEarningMechanismERR(errorMessages, error);
  }),
};

export default function* saga() {
  yield takeLatest(offerTypes.REQUEST_OFFER_OK, sagas.requestEarningMechanism);
}
